// TODO: Rename to something more sensible
export enum OperationForAuthorization {
    create = "d3b07384-d9a0-4f1f-9f1b-1a2b3c4d5e01",
    delete = "c3d4e5f6-2a3b-4d5e-8b9c-1234567890ab",
    read = "a1b2c3d4-e5f6-4a89-8123-456789abcdef",
    update = "b24f6c2e-1f2a-4c3d-9a2b-0f1e2d3c4b05",
}
